import React from 'react';
import { Box } from '../../components/UI-CHAKRA/Box';
import { Text } from '../../components/UI-CHAKRA/Text';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/mevo/close-error.svg';
import { Flex } from '../../components/UI-CHAKRA/Flex';
import { Certificate } from './certificates';
import { Button } from '../../components/UI-CHAKRA/Button';

interface OutOfServiceCertificateDialogProps {
  certificate: Certificate;
  description: string;
  onClick(): void;
}

export default function OutOfServiceCertificateDialog(props: OutOfServiceCertificateDialogProps) {
  return (
    <Box>
      <Flex justifyContent={'center'} mb={'20px'}>
        <img src={props.certificate.imagePath} alt="certificado" />
      </Flex>
      <Flex alignItems={'center'}>
        <CloseIcon />
        <Text ml={'10px'} fontSize={'18px'} lineHeight={'16px'} textAlign={'justify'} fontWeight={700}>
          {props.certificate.name}
          <Text as={'span'}> Indisponível</Text>
        </Text>
      </Flex>

      <Text m={'20px 0'} fontSize={'14px'} lineHeight={'16px'} textAlign={'justify'} fontWeight={400}>
        {props.description}
      </Text>

      <Button w={'100%'} borderRadius={'20px'} onClick={props.onClick}>
        Ok
      </Button>
    </Box>
  );
}
